import React from 'react';
import Button from '../../../../../component/button';
import { Group, Buttons } from '../styles';
import MilestoneItem from '../milestoneItem';
import { BUTTON_TYPE } from '../../../../../global/constants';
import { TaskModel } from '../../../../../mobx/models/task';
import { Milestone as MilestoneType } from '../../../../../mobx/interfaces/project';
import { StatusListInterface } from '../../../../../interfaces/ProjectInterface';

interface Props {
  archiveMilestoneList: MilestoneType[] | undefined;
  milestones: MilestoneType[] | undefined;
  showArchived: boolean;
  handleToggle: () => void;

  loadData: () => void;
  closeArchiveModal: () => void;
  selectedId: string;
  onChangeStatus: (task: TaskModel, status: StatusListInterface, previousStatus: StatusListInterface) => void;
  onClickTaskCheckBox: (task: TaskModel, status: boolean) => void;

  findOldestCreatedOnDate: (tasks: TaskModel[]) => string | null;
  findNewestDueDate: (tasks: TaskModel[]) => string | null;

  // Action callbacks to replace individual state setters
  onOpenDeleteModal: (milestoneId: string) => void;
  onOpenArchiveModal: (milestoneId: string) => void;
  onOpenEditModal: (milestone: MilestoneType) => void;
  onOpenCreateTask: (milestone: MilestoneType) => void;
  onOpenDeleteTask: (task: TaskModel) => void;
  onOpenTaskModal: () => void;
  onToggleCompletedTask: (value: boolean, itemId: string) => void;
  onSetButtonLoading: (value: boolean) => void;
}

const ArchiveMilestoneList: React.FC<Props> = React.memo(
  ({
    archiveMilestoneList,
    milestones,
    showArchived,
    handleToggle,
    loadData,
    closeArchiveModal,
    selectedId,
    onChangeStatus,
    onClickTaskCheckBox,
    findOldestCreatedOnDate,
    findNewestDueDate,
    onOpenDeleteModal,
    onOpenArchiveModal,
    onOpenEditModal,
    onOpenCreateTask,
    onOpenDeleteTask,
    onOpenTaskModal,
    onToggleCompletedTask,
    onSetButtonLoading
  }) => {
    if (!archiveMilestoneList || archiveMilestoneList.length === 0) return null;

    return (
      <>
        {milestones && milestones.length > 0 && (
          <Buttons>
            <Button
              title={showArchived ? 'Hide archived milestones' : 'Show archived milestones'}
              variant={BUTTON_TYPE.SECONDARY}
              onClick={handleToggle}
            />
          </Buttons>
        )}

        {showArchived && (
          <Group>
            {archiveMilestoneList.map((item, milestoneIndex) => {
              const newOldestDate = findOldestCreatedOnDate(item?.tasks);
              const newestDueDate = findNewestDueDate(item?.tasks);

              return (
                <MilestoneItem
                  key={item.id}
                  isMilestoneItem={false}
                  item={item}
                  loadData={loadData}
                  milestoneIndex={milestoneIndex}
                  newOldestDate={newOldestDate}
                  newestDueDate={newestDueDate}
                  closeArchiveModal={closeArchiveModal}
                  selectedId={selectedId}
                  onChangeStatus={onChangeStatus}
                  onClickTaskCheckBox={onClickTaskCheckBox}
                  onOpenDeleteModal={onOpenDeleteModal}
                  onOpenArchiveModal={onOpenArchiveModal}
                  onOpenEditModal={onOpenEditModal}
                  onOpenCreateTask={onOpenCreateTask}
                  onOpenDeleteTask={onOpenDeleteTask}
                  onOpenTaskModal={onOpenTaskModal}
                  onToggleCompletedTask={onToggleCompletedTask}
                  onSetButtonLoading={onSetButtonLoading}
                />
              );
            })}
          </Group>
        )}
      </>
    );
  }
);

export default ArchiveMilestoneList;
